import * as Sentry from '@sentry/nextjs';
import { usePathname } from 'next/navigation';

import SeoHead from '@/components/SeoHead/SeoHead';
import { LOCATION_ROUTES } from '@/helpers/locationPages';
import strapiApi from '@/helpers/strapi/api';
import { getLocations } from '@/helpers/strapi/helpers';
import { generateLogoStructuredData } from '@/helpers/strapi/structuredData';
import DefaultLayout from '@/layouts/default';
import Page from '@/templates/Page/Page';

function LocationsPage({ page, locations }) {
  const pathname = usePathname();

  return (
    <>
      <SeoHead
        title={page.attributes.title}
        description={page.attributes.description}>
        {generateLogoStructuredData(pathname)}
      </SeoHead>
      <Page
        page={page}
        pageProps={{
          locations,
        }}
      />
    </>
  );
}

LocationsPage.getLayout = function getLayout(page) {
  return (
    <DefaultLayout breadcrumbs={page.props.breadcrumbs}>{page}</DefaultLayout>
  );
};

export async function getServerSideProps() {
  try {
    const locations = await getLocations();

    const groupedLocations = locations.reduce((acc, loc) => {
      const state = loc.state ?? LOCATION_ROUTES.LOCATION_OTHER_LABEL;
      if (!acc[state]) {
        acc[state] = [];
      }
      acc[state].push(loc);
      return acc;
    }, {});

    const locationsByState = Object.entries(groupedLocations).map(
      ([state, cities]) => ({
        state,
        cities,
      })
    );

    const { data: pageData } = (
      await strapiApi.getPageByPathname(LOCATION_ROUTES.BASE_PATH)
    ).data;

    const breadcrumbs =
      (await strapiApi.getBreadcrumbsByPathname(LOCATION_ROUTES.BASE_PATH)).data
        ?.data ?? null;

    return {
      props: {
        page: pageData,
        locations: locationsByState,
        breadcrumbs,
      },
    };
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
}

export default LocationsPage;
